import { colors } from '@flowwai-frontend/shared/style-guide'

export const toastTheme = {
   ['DEFAULT']: {
      bgColor: 'bg-base-white',
      borderColor: 'border-gray-300',
      textColor: 'text-gray-700',
      closeIconColor: colors['gray-500'],
      leftIconColor: colors['gray-700']
   },
   ['PRIMARY']: {
      bgColor: 'bg-primary-25',
      borderColor: 'border-primary-300',
      textColor: 'text-primary-700',
      closeIconColor: colors['primary-500'],
      leftIconColor: colors['primary-600']
   },
   ['GRAY']: {
      bgColor: 'bg-gray-25',
      borderColor: 'border-gray-300',
      textColor: 'text-gray-700',
      closeIconColor: colors['gray-500'],
      leftIconColor: colors['gray-600']
   },
   ['SUCCESS']: {
      bgColor: 'bg-success-25',
      borderColor: 'border-success-300',
      textColor: 'text-success-700',
      closeIconColor: colors['success-500'],
      leftIconColor: colors['success-600']
   },
   ['FAILURE']: {
      bgColor: 'bg-error-25',
      borderColor: 'border-error-300',
      textColor: 'text-error-700',
      closeIconColor: colors['error-500'],
      leftIconColor: colors['error-600']
   },
   ['WARNING']: {
      bgColor: 'bg-warning-25',
      borderColor: 'border-warning-300',
      textColor: 'text-warning-700',
      closeIconColor: colors['warning-500'],
      leftIconColor: colors['warning-600']
   }
}
